<template>
  <Modal
    name="confirm"
    :class="context.modalClass"
    @close="closeModal"
    @open="onOpen"
  >
    <h3
      :data-i="context.headerIcon"
      class="mb-2"
      v-text="context.header || $t('common:modals.confirmHeader')"
    />
    <div v-if="bodyParagraphs">
      <p v-for="paragraph in bodyParagraphs" :key="paragraph">
        {{ paragraph }}
      </p>
    </div>
    <div class="flex items-center gap-2">
      <CButton
        ref="confirmRef"
        data-testid="btn-confirm"
        :icon="context.confirmIcon"
        iconBefore
        :color="context.confirmColor"
        width="fluid-width"
        @click="onConfirm"
      >
        {{ context.confirmText || $t('common:actions.confirm') }}
      </CButton>
      <CButton
        v-if="context.onCancel"
        width="fluid-width"
        :color="context.cancelColor || 'borderless'"
        :disabled="isConfirming"
        @click="onCancel"
      >
        {{ context.cancelText || $t('common:buttons.cancel') }}
      </CButton>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      isConfirming: false,
    };
  },
  computed: {
    context() {
      return this.$modal.context || {};
    },
    bodyParagraphs() {
      const { body } = this.context;
      if (!body) return;
      return Array.isArray(body) ? body : [body];
    },
  },

  methods: {
    async onConfirm() {
      this.isConfirming = true;
      return Promise.resolve(this.context.onConfirm()).finally(() => {
        this.isConfirming = false;
        this.$modal.close('confirm', { trigger: 'confirm' });
      });
    },

    async onCancel() {
      const cb = this.context.onCancel || (() => undefined);
      return Promise.resolve(cb()).finally(() => {
        this.$modal.close('confirm', { trigger: 'cancel' });
      });
    },

    closeModal() {
      if (this.context?.onClose) {
        return this.context.onClose();
      }
      if (this.context?.onCancel) {
        return this.context.onCancel();
      }
    },
    onOpen() {
      this.$refs.confirmRef?.$el?.focus();
    },
  },
};
</script>
